import { CoreUsersByIdNotificationPreferencesName } from './name';
import { coreUsersByIdNotificationsPreferencesUpdateSyncSlice } from './update';
import { patchUserNotificationPreferences } from '@api';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreUsersByIdNotificationPreferencesPatchAsyncSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.EMAIL_NOTIFICATION_PREFERENCE_UPDATED, ({ data }) => ({
				...data
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		preRequestActionCreators: [ coreUsersByIdNotificationsPreferencesUpdateSyncSlice.syncActionCreator ]
	},
	name: CoreUsersByIdNotificationPreferencesName,
	receive: false,
	request: true,
	requestHandler: patchUserNotificationPreferences
});
